import { gql } from "generated-graphql";

export const GET_STAFF_GENERATOR_STATUS_CHANGES = gql(`
  query StaffGeneratorStatusChanges(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
    $startDate: Date
    $endDate: Date
  ) {
    staffGeneratorStatusChanges(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      startDate: $startDate
      endDate: $endDate
    ) {
      items {
        facilityId
        facilityName
        tenantId
        tenantName
        state
        source
        periodStart
        previousPeriodStart
        reportedFederalStatus
        calculatedFederalStatus
        oldFederalStatus
        newFederalStatus
        oldStateStatus
        newStateStatus
        changeExplanation
        updatedAt
        openSubmission {
          id
          title
          status
          dueDate
          assigneeName
        }
        linkedSubmission {
          id
          title
          submissionType
          status
          dueDate
          assigneeName
        }
        resolutionStatus
      }
      count
      stats {
        totalChanges
        facilitiesChanged
        potentialExceedances
        exceedancesToLqg
        exceedancesToSqg
      }
    }
  }
`);
